// extracted by mini-css-extract-plugin
export default {"icons":"Client_icons__M13bS","selected-icons":"Client_selected-icons__IDEkA"};